import Vue from 'vue';
import Vuex from 'vuex';
import { auth } from '@/store/auth.module';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    project: sessionStorage.getItem('projectName'),
    projectIcon: sessionStorage.getItem('projectIcon'),
    projectId: sessionStorage.getItem('projectId'),
    uniqueEvent: sessionStorage.getItem('uniqueEventId'),
    availableSchedule: sessionStorage.getItem('availableSchedule'),
    availableClockEntries: sessionStorage.getItem('availableClockEntries'),
    availableN3: sessionStorage.getItem('availableN3'),
    typographyClass: localStorage.getItem('app-typography') || 'typography-opcion6',
    primaryColor: localStorage.getItem('app-primary-color') || '#F4796B',
    secondaryColor: localStorage.getItem('app-secondary-color') || '#00bfa5',
    darkTheme: localStorage.getItem('app-dark-theme') === 'true',
    darkThemeColor: localStorage.getItem('app-dark-theme-color') || '#121212',
    lightThemeColor: localStorage.getItem('app-light-theme-color') || '#F9F9FF',
    navColor: localStorage.getItem('app-nav-color') || '',
  },
  mutations: {
    setPrimaryColor(state, color) {
      state.primaryColor = color;
      localStorage.setItem('app-primary-color', color);
    },
    setSecondaryColor(state, color) {
      state.secondaryColor = color;
      localStorage.setItem('app-secondary-color', color);
    },
    setDarkTheme(state, isDark) {
      state.darkTheme = isDark;
      localStorage.setItem('app-dark-theme', isDark);
    },
    setDarkThemeColor(state, color) {
      state.darkThemeColor = color;
      localStorage.setItem('app-dark-theme-color', color);
    },
    setLightThemeColor(state, color) {
      state.lightThemeColor = color;
      localStorage.setItem('app-light-theme-color', color);
    },
    setNavColor(state, color) {
      state.navColor = color;
      localStorage.setItem('app-nav-color', color);
    },
    setTypographyClass(state, newClass) {
      state.typographyClass = newClass;
      localStorage.setItem('app-typography', newClass);
    },
    setProject(state, newProject) {
      state.project = newProject.text;
      state.projectIcon = newProject.icon;
      state.projectId = newProject.value;
      state.availableSchedule = newProject.availableSchedule;
      state.availableClockEntries = newProject.availableClockEntries;
      state.availableN3 = String(newProject.availableN3);
      sessionStorage.setItem('projectName', newProject.text);
      sessionStorage.setItem('projectIcon', newProject.icon);
      sessionStorage.setItem('projectId', newProject.value);
      sessionStorage.setItem('availableClockEntries', newProject.availableClockEntries);
      sessionStorage.setItem('availableSchedule', newProject.availableSchedule);
      sessionStorage.setItem('availableN3', newProject.availableN3);
    },
    clearProject(state) {
      state.project = null;
      state.projectIcon = null;
      state.projectId = null;
      state.availableClockEntries = null;
      state.availableSchedule = null;
      state.availableN3 = null;
      sessionStorage.removeItem('projectName');
      sessionStorage.removeItem('projectIcon');
      sessionStorage.removeItem('projectId');
      sessionStorage.removeItem('availableClockEntries');
      sessionStorage.removeItem('availableSchedule');
      sessionStorage.removeItem('availableN3');
    },
    setUniqueEventId(state, newUniqueEvent) {
      state.uniqueEvent = newUniqueEvent;
      sessionStorage.setItem('uniqueEventId', newUniqueEvent);
    },
  },
  actions: {
  },
  modules: {
    auth,
  },
});
